import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { BaseService } from 'ngx-elvis-ds';
import { Barcode, ScanSettings, BarcodePicker } from 'scandit-sdk';
import * as Scandit from 'scandit-sdk';
import { SAMService } from '../sam/sam.service';
import { CartService } from './cart.service';
import { ConfigService } from '../config.service';
@Injectable({
  providedIn: 'root'
})
export class ScanditService extends BaseService {

  duplicateFilterTimeout: number = 1500;
  enabled: boolean = false;
  barcodePicker: BarcodePicker;
  scanSettings = new ScanSettings({
    enabledSymbologies: [
      Barcode.Symbology.EAN8,
      Barcode.Symbology.EAN13,
      Barcode.Symbology.UPCA,
      Barcode.Symbology.UPCE,
      Barcode.Symbology.CODE128,
      Barcode.Symbology.CODE39,
      Barcode.Symbology.CODE93,
      Barcode.Symbology.QR,
      Barcode.Symbology.INTERLEAVED_2_OF_5
    ],
    codeDuplicateFilter: this.duplicateFilterTimeout
  });

  constructor(
    private platform: Platform,
    public sam: SAMService,
    public samCart: CartService,
    private configSvc: ConfigService
  ) {
    super();
  }

  async onInit() {
    const SCANDIT_API_KEY = this.configSvc.guiSettings.scanditLicenseKey;
    await Scandit.configure(SCANDIT_API_KEY, { engineLocation: 'https://unpkg.com/scandit-sdk/build' });
  }

  onActivate() {
    if ( document.querySelector('#triggerButton') ) {
      document.querySelector('#triggerButton').classList.add('active');
    }
    this.barcodePicker.resumeScanning();
    this.enableBarcodePicker(true);
  }

  onDeactivate() {
    if (document.querySelector('#triggerButton')) {
      document.querySelector('#triggerButton').classList.remove('active');
    }
    this.enableBarcodePicker(false);
  }

  setScanMode(enable:boolean) {
    if (enable) {
      BarcodePicker.create(document.getElementById('scandit-element'), {
        playSoundOnScan: true,
        vibrateOnScan: true
      }).then( (barcodePicker: BarcodePicker) => {
        this.barcodePicker = barcodePicker;

        this.barcodePicker.pauseScanning();
        this.barcodePicker.applyScanSettings(this.scanSettings);
        
        this.barcodePicker.on('scan', scanSession => {
          const foundCode = scanSession.barcodes[0].data;
          this.sam.onSend({
            Command: 'LOOKUP',
            Val: foundCode,
            parms: {
              Qty: this.samCart.counters.qty
            }
          });
        });

        if (window.innerWidth > 768) {
          this.enableBarcodePicker(true);
        }
      });
    } else {
      if (this.barcodePicker) {
        this.barcodePicker.destroy();
      }
      document.getElementById('scandit-element').remove();
    }
  }

  // private

  private enableBarcodePicker(enable: boolean = true, pauseCamera: boolean = false) {
    if (this.barcodePicker) {
      if (enable) {
        this.barcodePicker.resumeScanning();
        this.enabled = true;
      } else {
        this.barcodePicker.pauseScanning(pauseCamera);
        this.enabled = false;
      }
    }
  }
}